import React from 'react'
import { Box, Button, Flex, Image } from '@chatterbug/aaron'
import warning from './assets/warning.svg'

import BannerSkeleton from '../BannerSkeleton'

export type Props = {
  message: string
  buttonLink: string
  buttonMessage: string
}

const BannerWarning: React.FC<Props> = ({
  message,
  buttonLink,
  buttonMessage,
}) => {
  return (
    <BannerSkeleton
      backgroundColor="blue42"
      contentSection={
        <Flex alignItems="center">
          <Box
            minWidth="24px"
            display={{ _: 'none', tablet: 'block' }}
            alignSelf="flex-start"
          >
            <Image src={warning} />
          </Box>
          <Box
            ml="1x"
            color="white100"
            textAlign={{ _: 'left', laptop: 'center' }}
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          />
        </Flex>
      }
      buttonSection={
        <Flex alignItems="center" justifyContent="center">
          <Button
            href={buttonLink}
            type="primaryAdvanced"
            style={{ border: '1px solid white', overflowY: 'hidden' }}
          >
            <Flex alignItems="center">
              <Image
                src={warning}
                display={{ _: 'inline-block', tablet: 'none' }}
                mr="1x"
              />
              {buttonMessage}
            </Flex>
          </Button>
        </Flex>
      }
    />
  )
}

export default BannerWarning
